import   React              from "react";

import   classNames         from "classnames";

import   styles              from "./AdminActionLogManagment.module.scss";

import   AdminActionLogList  from "./AdminActionLogList";

export interface AdminActionLogManagmentProps {
  adminId: number;
}

// Onglet "Logs" de la fiche créateur : historique AdminActionLog (+ connexions
// UserActionLog fusionnées côté back) le concernant — même pattern que
// SentEmailManagment/PurchaseManagment.
export const AdminActionLogManagment: React.FC<AdminActionLogManagmentProps> = ({ adminId }) => {

  return (
    <div className={classNames(styles.root)}>
      <AdminActionLogList adminId={adminId} />
    </div>
  );
};

export default AdminActionLogManagment;
